export default __webpack_public_path__ + "static/media/google.49668dcd.svg";